import { render, staticRenderFns } from "./TipusBorraList.vue?vue&type=template&id=765399a0&scoped=true"
import script from "./TipusBorraList.vue?vue&type=script&lang=js"
export * from "./TipusBorraList.vue?vue&type=script&lang=js"
import style0 from "./TipusBorraList.vue?vue&type=style&index=0&id=765399a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765399a0",
  null
  
)

export default component.exports